import type { ShowEndpointQueryParams } from "@circle-react/api/paywallCheckoutApi.types";
import { absolutePath } from "../../absolutePath";
import { paywallCheckoutAttempt } from "./attempts";
import { paywallCheckoutVerifications } from "./verifications";

interface PaywallCheckoutFnProps<T> {
  params?: T;
  paywallCheckoutPath?: string;
}

export const paywallCheckout = {
  show: ({ params }: PaywallCheckoutFnProps<ShowEndpointQueryParams>) =>
    absolutePath("paywalls/checkout/", params),
  preview: ({
    params = {},
  }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
    absolutePath("paywalls/checkout/preview", params),
  prepare: ({
    params = {},
  }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
    absolutePath("paywalls/checkout/prepare", params),
  create: ({
    params = {},
  }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
    absolutePath("paywalls/checkout/", params),
  complete: ({
    params = {},
  }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
    absolutePath("paywalls/checkout/complete", params),
  cancel: ({
    params = {},
  }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
    absolutePath("paywalls/checkout/cancel", params),

  attempts: paywallCheckoutAttempt,
  verifications: paywallCheckoutVerifications,
  emailVerifications: {
    create: ({
      params = {},
    }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
      absolutePath("paywalls/checkout/email_verification", params),
  },
  otpSessions: {
    create: ({
      params = {},
    }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
      absolutePath("paywalls/checkout/otp_sessions", params),
  },
  sessions: {
    create: ({
      params = {},
    }: PaywallCheckoutFnProps<Record<string, unknown>> = {}) =>
      absolutePath("paywalls/checkout/sessions", params),
  },
};
